import request from '../common/request.js'

export function getJobList() {
    return request({
        url: '/z-other/job/mobile'
    })
}